<template>
  <div class="activityList-box">
    <!-- 操作栏 -->
    <div class="action-bar">
      <el-select v-model="params.activityId" size="small" placeholder="请选择活动" filterable clearable>
        <el-option v-for="item in actIDs" :value="item.value" :label="item.label" :key="item.value"></el-option>
      </el-select>
      <el-select v-model="params.model" size="small" placeholder="请选择奖池模式" filterable clearable>
        <el-option v-for="item in models" :value="item.value" :label="item.label" :key="item.value"></el-option>
      </el-select>
      <el-button type="primary" size="small" @click="searchActive()">搜索</el-button>
      <el-button type="primary" size="small" @click="activeAction('add')">+新增奖池</el-button>
    </div>
    <!-- 表格数据 -->
    <el-table :data="tableData" border style="width: 100%" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
      <el-table-column prop="activityId" label="活动" align="center" :show-overflow-tooltip="true" min-width="220" fixed>
        <template slot-scope="scope">
          {{formatterAct(scope.row.activityId)}}
        </template>?
      </el-table-column>
      <el-table-column prop="model" label="奖池模式" align="center" :show-overflow-tooltip="true" width="120">
        <template slot-scope="scope">
          <span> {{modelType(scope.row.model)}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="price" label="单次抽奖金额" align="center" :show-overflow-tooltip="true" min-width="120">
      </el-table-column>
      <el-table-column prop="freeCount" label="免费次数" align="center" :show-overflow-tooltip="true" min-width="120"></el-table-column>
      <el-table-column prop="estimatedIncome" label="预计当日收益" align="center" :show-overflow-tooltip="true" min-width="120"></el-table-column>
      <el-table-column prop="reservoir" label="蓄水池" align="center" :show-overflow-tooltip="true" min-width="120"></el-table-column>
      <el-table-column prop="systemIncome" label="系统收益" align="center" :show-overflow-tooltip="true" min-width="120"></el-table-column>
      <el-table-column prop="systemRake" label="系统抽成金额" align="center" :show-overflow-tooltip="true" min-width="120"></el-table-column>
      <el-table-column prop="startTime" label="创建时间" align="center" :show-overflow-tooltip="true" min-width="200">
        <template slot-scope="scope">{{ scope.row.createTimt | changeDate }}</template>
      </el-table-column>
      <el-table-column prop="endTime" label="更新时间" align="center" :show-overflow-tooltip="true" min-width="200">
        <template slot-scope="scope">{{ scope.row.updateTime | changeDate }}</template>
      </el-table-column>

      <el-table-column prop="operating" label="操作" align="center" width="160" fixed="right">
        <template slot-scope="scope">
          <el-button type="success" size="mini" icon="el-icon-edit" @click="activeAction('edit', scope.row)"></el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页组件-->
    <el-pagination :page-sizes="[5, 10, 15, 20]" :current-page="params.pageNumber" :page-size="params.pageSize" layout="total, sizes, prev, pager, next, jumper" background @size-change="changeSize" :total="total" @current-change="changeCurrent"></el-pagination>
    <!--新增、编辑tag弹窗-->
    <prize-list-action ref="activeAction" :actIDs="actIDs" @handlerList="handlerActiveList"></prize-list-action>
  </div>
</template>
<script>
import PrizeListAction from "./components/prizeListAction";
import API from "@/api";
import { paramsFilter } from "@/utils/global";
export default {
  data() {
    return {
      tableData: [],
      loading: false,
      total: 0,
      time: "",
      models: [
        {
          value: 1,
          label: "棋牌游戏",
        },
        {
          value: 2,
          label: "免费",
        },
      ],
      actIDs: [],
      params: {
        model: "",
        activityId: "",
        pageNumber: 1,
        pageSize: 10,
      },
    };
  },
  components: {
    PrizeListAction,
  },
  created() {
    this.getPrizePool();
    this.getActiveityId();
  },
  methods: {
    // 获取活动ID
    getActiveityId() {
      API.getActiveityId(this.params).then((res) => {
        if (res.code === 200 && res.data) {
          this.actIDs = res.data;
          return;
        }
        this.$message.error("获取活动失败");
      });
    },
    getPrizePool() {
      this.loading = true;
      let formData = paramsFilter(this.params);
      API.getPrizePool(formData)
        .then((res) => {
          if (res.code === 200 && res.data.list) {
            this.tableData = res.data.list;
            this.total = res.data.count;
          } else {
            this.tableData = [];
            this.total = 0;
          }
          this.loading = false;
        })
        .catch(() => {
          this.tableData = [];
          this.loading = false;
        });
    },
    formatterAct(id) {
      return this.actIDs.filter((item) => item.value == id).length > 0
        ? this.actIDs.filter((item) => item.value == id)[0].label
        : "未知";
    },
    modelType(model) {
      return this.models.filter((item) => item.value == model).length > 0
        ? this.models.filter((item) => item.value == model)[0].label
        : "未知";
    },
    // 搜索列表
    searchActive() {
      this.getPrizePool();
    },
    // pageSize发生变化触发
    changeSize(size) {
      this.params.pageSize = size;
      this.formparamsData.pageNumber = 1;
      this.getPrizePool();
    },
    // 当前页发生变化触发
    changeCurrent(pageNumber) {
      this.params.pageNumber = pageNumber;
      this.getPrizePool();
    },
    // 编辑活动成功回掉
    handlerActiveList() {
      this.getPrizePool();
    },
    // 新增、删除tags
    activeAction(type, data) {
      this.$refs.activeAction.open(type, data);
    },
  },
};
</script>
<style>
</style>
